/**
 * @typedef {Object} ProductImage
 * @property {number} id
 * @property {string} url
 */

/**
 * @typedef {Object} Product
 * @property {number} id
 * @property {string} name
 * @property {string|null} description
 * @property {number} price
 * @property {string} currency
 * @property {number} categoryId
 * @property {string} categoryName
 * @property {boolean} isActive
 * @property {number} displayOrder
 * @property {ProductImage[]} images
 * @property {string|null} primaryImageUrl
 */

/**
 * @param {any} dto
 * @returns {ProductImage}
 */
function normalizeProductImage(dto) {
  return {
    id: Number(dto?.id ?? 0),
    url: String(dto?.url ?? ""),
  };
}

/**
 * Normalize API product shape to a safe UI-friendly object.
 * @param {any} dto
 * @returns {Product}
 */
export function normalizeProduct(dto) {
  const images = Array.isArray(dto?.images) ? dto.images.map(normalizeProductImage) : [];
  const primaryImageUrl = images?.[0]?.url || null;

  return {
    id: Number(dto?.id ?? 0),
    name: String(dto?.name ?? ""),
    description: dto?.description ?? null,
    price: Number(dto?.price ?? 0),
    currency: String(dto?.currency ?? ""),
    categoryId: Number(dto?.categoryId ?? 0),
    categoryName: String(dto?.categoryName ?? ""),
    isActive: Boolean(dto?.isActive),
    displayOrder: Number(dto?.displayOrder ?? 0),
    images,
    primaryImageUrl,
  };
}
